'use client';

import Icon from '@/components/ui/AppIcon';
import { QuoteFormData } from './SmartQuoteForm';

interface ProjectDetailsProps {
  formData: QuoteFormData;
  updateFormData: (updates: Partial<QuoteFormData>) => void;
}

export default function ProjectDetails({ formData, updateFormData }: ProjectDetailsProps) {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h2 className="text-2xl font-headline font-bold text-foreground">
          Project Information
        </h2>
        <p className="text-muted-foreground font-body">
          Tell us about your project and how we can reach you.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <label className="block text-sm font-cta font-semibold text-foreground">
            Project Name <span className="text-error">*</span>
          </label>
          <input
            type="text"
            value={formData.projectName}
            onChange={(e) => updateFormData({ projectName: e.target.value })}
            placeholder="e.g., Precision Enclosure Manufacturing"
            className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-base"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-cta font-semibold text-foreground">
            Company Name
          </label>
          <input
            type="text"
            value={formData.companyName}
            onChange={(e) => updateFormData({ companyName: e.target.value })}
            placeholder="Your company name"
            className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-base"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-cta font-semibold text-foreground">
            Contact Name <span className="text-error">*</span>
          </label>
          <input
            type="text"
            value={formData.contactName}
            onChange={(e) => updateFormData({ contactName: e.target.value })}
            placeholder="Your full name"
            className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-base"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-cta font-semibold text-foreground">
            Email Address <span className="text-error">*</span>
          </label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) => updateFormData({ email: e.target.value })}
            placeholder="your.email@company.com"
            className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-base"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-cta font-semibold text-foreground">
            Phone Number <span className="text-error">*</span>
          </label>
          <input
            type="tel"
            value={formData.phone}
            onChange={(e) => updateFormData({ phone: e.target.value })}
            placeholder="(555) 123-4567"
            className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-base"
          />
        </div>
      </div>

      <div className="bg-accent/10 rounded-xl p-6 border border-accent/20">
        <div className="flex items-start space-x-3">
          <Icon name="InformationCircleIcon" size={24} variant="solid" className="text-accent flex-shrink-0" />
          <div className="space-y-2">
            <div className="text-sm font-cta font-semibold text-foreground">
              What happens next?
            </div>
            <ul className="text-sm text-muted-foreground font-body space-y-1">
              <li>• Upload your technical drawings (DXF, STEP, DWG files)</li>
              <li>• Select material specifications and quantities</li>
              <li>• Review your quote request before submission</li>
              <li>• Receive detailed pricing within 24-48 hours</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}